module.exports = __webpack_public_path__ + "img/social5.5aea7aa4.png";